import './SectionIntro.css';
import React, { useRef, useEffect } from 'react';
import { get, replaceWhitespace } from '../../utils';
import { Text, RichText, Link } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../atoms/RouterLink';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { useHistory } from 'react-router-dom';
function handleScrollToRef(scrollElemRef, extraHeightCalculator) {
  if (!scrollElemRef.current) {
    return;
  }
  var scrollElem = scrollElemRef.current;
  if (!scrollElem) {
    return;
  }
  var mainHeight = 0;
  // NOTE: this class name is declared in the MainNavigation component.
  var mainNav = document.querySelector('.main-nav.main-nav-static');
  if (mainNav) {
    mainHeight = mainNav.clientHeight;
  }
  var extraHeight = extraHeightCalculator && mainNav ? extraHeightCalculator(mainNav) : 0;
  var combinedHeight = mainHeight + extraHeight + 10;
  var rect = scrollElem.getBoundingClientRect();
  var scrollPosition = rect.top + (window.pageYOffset || document.documentElement.scrollTop);
  window.scrollTo(0, scrollPosition - combinedHeight);
}
export var SectionIntro = function SectionIntro(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var history = useHistory();
  var hash = history.location.hash && decodeURI(history.location.hash.split('#')[1]) || null;
  var componentRef = useRef(null);
  var extraHeightCalculator = function extraHeightCalculator(mainNavElem) {
    return parseInt(window.getComputedStyle(mainNavElem, '::after').height || '');
  };
  useEffect(function () {
    if (fields.data.item && fields.data.item.title.jss.value && hash && fields.data.item.title.jss.value == hash) {
      handleScrollToRef(componentRef, extraHeightCalculator);
    }
  }, [hash]);
  if (!fields || !fields.data.item) {
    console.info('SectionIntro component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [SectionIntro component is empty: please provide data source]");
    }
    return null;
  }
  var hasTitle = Boolean(get(fields, 'data.item.title.jss.value')) || false;
  var hasDescription = Boolean(get(fields, 'data.item.description.jss.value')) || false;
  var hasLink = Boolean(get(fields, 'data.item.ctaLink.jss.value.href') && get(fields, 'data.item.ctaLabel.jss.value')) || false;
  var learnMoreAnalytics = fields.data.learnMoreAnalytics;
  var item = fields.data.item;
  var renderLink = function renderLink() {
    if (!hasLink) return null;
    var linkAlt = '';
    if (hasTitle) {
      linkAlt = get(fields, 'data.item.title.jss.value');
    }
    linkAlt = linkAlt ? "".concat(linkAlt, " | ").concat(fields.data.item.ctaLabel.jss.value) : fields.data.item.ctaLabel.jss.value;
    if (pageEditing) return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
      field: fields.data.item.ctaLabel
    })), "Link: ", /*#__PURE__*/React.createElement(Link, {
      field: fields.data.item.ctaLink
    }));
    return /*#__PURE__*/React.createElement("div", null, item ? /*#__PURE__*/React.createElement(RouterLink, {
      href: fields.data.item.ctaLink.jss.value.href,
      className: "btn btn-secondary",
      title: linkAlt,
      linktype: fields.data.item.ctaLink.jss.value.linktype,
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickData(learnMoreAnalytics, params), fields.data.item.name);
      }
    }, /*#__PURE__*/React.createElement("span", null, fields.data.item.ctaLabel.jss.value)) : null);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    pageEditing: pageEditing,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, item ? /*#__PURE__*/React.createElement("div", {
    className: "section-intro",
    id: replaceWhitespace(fields.data.item.title.jss.value.trim()),
    "data-cy": "section-intro",
    ref: componentRef
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    className: "h3 section__title",
    tag: "h3",
    field: fields.data.item.title.jss
  }), hasDescription && /*#__PURE__*/React.createElement(RichText, {
    className: "body-small s__desc",
    tag: "div",
    field: fields.data.item.description.jss
  }), renderLink()) : null);
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    pageEditing = _ref2.pageEditing,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: " ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(pageEditing && onPageEditor)
  }, children);
};
var onPageEditor = "o11e36is";
var commonStyles = "cyx0dg4";
var ltrStyles = "lj5olca";
var rtlStyles = "r1hlurtl";
export default SectionIntro;